<template>
    <therapist-select/>
</template>

<script>
import TherapistSelect from "@/views/TherapistSelect.vue";

export default {
    name: "therapist",
    components: {TherapistSelect},
}
</script>

<style scoped>

</style>
